import React, { useState, useRef, useCallback, useEffect, useMemo } from "react";
import moment from "moment";
import { Heatmap } from '@mui/x-charts-pro/Heatmap';
import { GetHeatMapData, GetXLSXDataHeatmap } from './ChartsV2Functions';
import "./ChartV2.css";
import { selectDateOptions } from "components/Analyses/DatesOptions";
import uuid from "react-uuid";
import { interpolateBlues, interpolateRdYlBu } from 'd3-scale-chromatic';
import { charttext } from 'variables/chart';
import {
    ContinuousColorLegend,
} from '@mui/x-charts/ChartsLegend';
import { chartsTooltipClasses } from '@mui/x-charts/ChartsTooltip';

export default function ChartV2Heatmap(props) {
    const { chart, data, setData } = props;

    useEffect(() => {
        chart.series.forEach((serie) => {
            serie.uuid = uuid();
        });
        let datatmp = GetHeatMapData(chart);
        setData(datatmp);
        GetXLSXDataHeatmap(chart);
    }, []);

    const dateFormatter = new Intl.DateTimeFormat('fr-FR', {
        // weekday: 'short',
        day: 'numeric',
        month: 'numeric',
        year: 'numeric',
    }).format;

    const monthFormatter = new Intl.DateTimeFormat('fr-FR', {
        month: 'numeric',
        year: 'numeric',
    }).format;

    //console.log(data);
    // console.log(groupedseries);
    return (

        <div style={{ width: "100%", height: "100%" }}>
            {
                data?.data && data.data.length > 0 ?
                    <Heatmap
                        // hideLegend={true}
                        // slots={{
                        // legend: <ContinuousColorLegend
                        //     minLabel={data.min || 0}
                        //     maxLabel={data.max || 0}
                        // />
                        // legend: ContinuousColorLegend
                        // legend: ContinuousColorLegend
                        // }}
                        // slotProps={{
                        //     legend: {
                        //         direction: 'horizontal',
                        //         position: { horizontal: 'middle' },
                        //         sx: { width: 200 },
                        //         minLabel: ''+data.min || '0',
                        //         maxLabel: ''+data.max || '0',
                        //     },
                        // }}
                        slotProps={{
                            tooltip: {
                                sx: {
                                    [`&.${chartsTooltipClasses.root} .${chartsTooltipClasses.valueCell}`]: {
                                        color: '#636363',
                                        fontSize: '15px',
                                    },
                                },
                            },
                        }}
                        xAxis={[
                            {
                                data: data.xaxis || [],
                                label: '',
                                valueFormatter: (value, context) => {
                                    return chart.heatmapparameters.heatmapdisplay === 'hourday' ? dateFormatter(value) : monthFormatter(value);
                                },
                                tickLabelStyle: { angle: 45 },
                                height: 70,
                            },
                        ]}
                        yAxis={[
                            {
                                data: data.yaxis || [],
                                label: '',
                                tickLabelInterval: (_, index) => index % 2 === 0,
                                valueFormatter: (value) => chart.heatmapparameters.heatmapdisplay === 'hourday' ? `${value}h` : `${value}`,
                                width: 60,
                            },
                        ]}
                        zAxis={[
                            {
                                min: data.min || 0,
                                max: data.max || 0,
                                colorMap: {
                                    type: 'continuous',
                                    color: (t) => chart.heatmapparameters.heatmapcolor === 'bluered' ? interpolateRdYlBu(1 - t) : interpolateBlues(t),
                                },
                            },
                        ]}
                        series={[
                            {
                                label: chart.series[0].name,
                                data: data.data || [],
                                valueFormatter: (v, { dataIndex }) => {
                                    // console.log(v);
                                    const val = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(v[2]);
                                    return `${val} ${chart.yaxis1unit}`;
                                },
                            },
                        ]}
                    /> : <></>
            }


        </div>

    );
}